import { QUERY_PARAM_LOGGOUT } from '~~/lib/constants';
import { ensureArray } from '~/utils/ensureArray';
import { VISIBILITY_OPTIONS } from '~/utils/entry/isVisible';

/**
 * Builds the Basler ID logout URL with a redirect target after logout.
 *
 * If the current page is a protected page (requires authentication), the redirect
 * target is the locale home page to prevent an immediate re-login redirect loop.
 * Otherwise, the current page (including its query parameters) is used as the
 * redirect target.
 *
 * @returns The complete logout URL string
 */
export default function buildAuthLogoutUri(): string {
  const route = useRoute();
  const { $pageVisibility } = useNuxtApp();
  const locale = String(
    ensureArray(route.params.locale).filter(Boolean)[0] ?? 'de-de'
  );

  const isNotPublicPage = $pageVisibility.value !== VISIBILITY_OPTIONS.public;

  const redirectPath = isNotPublicPage ? `/${locale}/` : route.path;
  const redirectSearchParams = new URLSearchParams(
    isNotPublicPage ? {} : (route.query as Record<string, string>)
  );
  redirectSearchParams.append(QUERY_PARAM_LOGGOUT, '');

  const redirectTarget = `${redirectPath}?${redirectSearchParams.toString()}`;

  return buildUrlString(
    '',
    '/auth/entra/logout',
    `redirect=${encodeURIComponent(redirectTarget)}`,
    undefined,
    true,
    false
  );
}
